import { ResponceDataType } from "../ErrorCode"

export const PLCManualCollectionRequest = (deviceIndex: number): Promise<ResponceDataType> => {
  return new Promise((resolve, reject) => {
    fetch("api/PLCCommunicate/PLCManualCollection",{
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(deviceIndex),
    })
    .then((res) => res.json())
    .then((result: ResponceDataType) => resolve(result))
    .catch(reason => reject(reason));
  });
}

export const PLCStudyRequest = (deviceIndex: number): Promise<ResponceDataType> => {
  return new Promise((resolve, reject) => {
    fetch("api/PLCCommunicate/PLCStudyRequest",{
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(deviceIndex),
    })
    .then((res) => res.json())
    .then((result: ResponceDataType) => resolve(result))
    .catch(reason => reject(reason));
  });
}

export const PLCStudyCancelRequest = (deviceIndex: number): Promise<ResponceDataType> => {
  return new Promise((resolve, reject) => {
    fetch("api/PLCCommunicate/PLCStudyCancelRequest",{
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(deviceIndex),
    })
    .then((res) => res.json())
    .then((result: ResponceDataType) => resolve(result))
    .catch(reason => reject(reason));
  });
}
